import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters('auth', ['userPosition']),
    ...mapState('auth', {
      sshcpMapping: 'sshcpMapping'
    }),
    localUserProfile() {
      return JSON.parse(localStorage.userProfile) || {};
    },
    localUserPosition() {
      return (
        this.userPosition ||
        this.localUserProfile.potition ||
        ''
      ).toLowerCase();
    },
    isLoggedInAsDirector() {
      return (
        this.localUserPosition.includes('director') &&
        !this.localUserPosition.includes('finance')
      );
    },
    isLoggedInAsFinance() {
      return [
        'finance_cbu_director',
        'finance_department_head',
        'finance_manager'
      ].includes(this.localUserPosition);
    },
    isLoggedInAsBO() {
      return this.localUserProfile.position
        ? this.localUserProfile.position.is_bo
        : this.localUserProfile.name.includes('inputter');
    },
    isLoggedInAsDeptHead() {
      return this.localUserPosition === 'dept_head';
    },
    isLoggedInAsBrandHead() {
      return this.localUserPosition === 'brand_head';
    },
    userMapping() {
      try {
        return JSON.parse(localStorage.user_mapping);
      } catch (e) {
        return [];
      }
    },
    isHNUser() {
      return (
        this.userMapping.filter(item => item.role === 'HN User').length > 0
      );
    },
    isLoggedInAsHN() {
      return this.localUserProfile.mapping.divisi.alias === 'hn';
    },
    isLoggedInAsSales() {
      return (
        this.localUserProfile.mapping.divisi.alias === 'sales' ||
        this.localUserProfile.viewDivision
          .map(item => item.alias)
          .includes('sales')
      );
    },
    isLoggedInAsBOSSHCP() {
      return this.sshcpMapping.some(item => item.group_name === 'Budget Owner');
    },
    isLoggedInAsFOMSSHCP() {
      return this.sshcpMapping.some(item => item.group_name === 'FOM');
    }
  }
};
